import { CompositeScreenProps } from "@react-navigation/native"
import * as React from "react"
import { Platform, ViewStyle } from "react-native"
import { SafeAreaView } from "react-native-safe-area-context"
import { color } from "../../theme"
import { Button } from "../button/button"
import { JalaIcon } from "../jala-icon/jala-icon"
import { Text } from "../text/text"
import { View } from 'native-base'
import { HeaderProps } from "./common-header.props"
import { observer } from "mobx-react-lite"
import { IViewProps } from "native-base/lib/typescript/components/primitives/View"


const CONTAINER = (height): ViewStyle => ({
  justifyContent: "space-between",
  backgroundColor: color.primary,
  flexDirection: "row",
  height: height
})

const HEADER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center'
}

const MARGIN = (width):ViewStyle => ({
  marginRight: width
})

const BACK_BUTTON: ViewStyle = {
  marginLeft: 16,
  marginRight: 12
}

export const BetaIcon: React.FC<{colorScheme?: "light" | "dark"} & IViewProps> = ({colorScheme, ...restProps}) => {
  return (
    <View
      width={"39px"}
      height={"22px"}
      backgroundColor={color.palette.red}
      justifyContent={"center"}
      alignItems={"center"}
      borderRadius={"4px"}
      {...restProps}
    >
     <Text colorScheme={colorScheme} color={color.palette.white} preset="title5" tx="chemicalParameterScreen.beta"/>
    </View>
  )
}

/**
 * Header that appears on many screens. Will hold navigation buttons and screen title.
 */
export const CommonHeader: React.FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps <any, any> & HeaderProps> = observer(function HeaderWithShare(props: HeaderProps) {
  const { colorScheme, title, navigation, style, headerHeight = 55.8, onPressRight, isBeta } = props
  const backIcon = Platform.OS === "ios" ? 'arrow_back_ios' : 'arrow_back';

  return (
    <View style={style} backgroundColor={color.primary}>
      <SafeAreaView edges={["top"]} />
      <View style={CONTAINER(headerHeight)}>
        <View style={HEADER}>
          <Button testID="jala:id/back-button" preset="link" textPreset="display1" style={BACK_BUTTON} colorScheme={colorScheme} onPress={navigation.goBack}>
            <JalaIcon name={backIcon} size={25} color={color.palette.white} />
          </Button>
          <Text text={title} preset="title2" color={color.palette.white} />
          {isBeta && <BetaIcon marginLeft={"8px"} colorScheme={colorScheme} />}
        </View>

        { onPressRight &&
          <View style={HEADER}>
            <Button testID="jala:id/right-button" preset="link" style={MARGIN(12)} onPress={onPressRight}>
              <JalaIcon name="info-lamp" size={25} color={color.palette.white} />
            </Button>
          </View>
        }
      </View>
    </View>
  )
})
